import React from "react";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import EmailIcon from '@mui/icons-material/Email';
import {CCardLink, 
    CContainer, 
    CCol,
    CRow
} from "@coreui/react-pro";
const Contact = () => {
    const mainContainerStyle = {
        height: '100vh',
      };

    const gridStyle = {
        width: '350px',
    };
    return(
        <div className="Contact d-flex flex-column align-items-center justify-content-center" style={mainContainerStyle}>
            <h1 className="text-center mb-5">Contact Us</h1>
            <div className="text-gray row justify-content-center col-md-auto" style={gridStyle}>
            <CRow className="justify-content-center" >
                <CCol xs={2} className="text-light"><LocationOnIcon className="fs-2"/></CCol>
                <CCol xs={8} ><p>Shower Away Pty Ltd <br />
                        Suite 1088, 30 Denison St <br />
                        Bondi NSW 2022 <br />
                        ABN: 60 661 931 684</p></CCol>
            </CRow>
            <CRow className="justify-content-center">
                <CCol xs={2} className="text-light"><LocalPhoneIcon className="fs-2"/></CCol>
                <CCol xs={8}><p>0430 525 188 (Peter)</p></CCol>
            </CRow>
            <CRow className="justify-content-center">
                <CCol xs={2} className="text-light"><EmailIcon className="fs-2"/></CCol>
                <CCol xs={8}><CCardLink href="mailto: hello@showeraway.com" className="text-gray">hello@showeraway.com</CCardLink></CCol>
            </CRow>
            </div>
        </div>
    )
}

export default Contact;


